var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import DataForm from "~/components/common/data-form.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Dependencies } from "~/core/decorator";
import { Watch, Prop, Emit } from "vue-property-decorator";
import { DataImportService } from "~/services/dataimp-service/data-import.service";
var ImportCaseDetail = /** @class */ (function (_super) {
    __extends(ImportCaseDetail, _super);
    function ImportCaseDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            batchNumber: '',
            name: '',
            certificateNo: ''
        };
        _this.loading = {
            state: false
        };
        _this.dataSet = [];
        return _this;
    }
    ImportCaseDetail.prototype.updateCaseDetail = function () {
        this.searchModel.batchNumber = this.batchNumber;
        this.refreshData();
    };
    /**
     * 刷新列表数据
     */
    ImportCaseDetail.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.dataImportService.getImportDataExcelCaseDetailList(this.searchModel, this.pageService, this.sortService, this.loading).subscribe(function (data) { return _this.dataSet = data; });
    };
    ImportCaseDetail.prototype.reset = function () {
        this.searchModel = {
            batchNumber: '',
            name: '',
            certificateNo: ''
        };
    };
    /**
     * 返回
     */
    ImportCaseDetail.prototype.onBackCaseList = function () { };
    __decorate([
        Dependencies(PageService)
    ], ImportCaseDetail.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], ImportCaseDetail.prototype, "sortService", void 0);
    __decorate([
        Dependencies(DataImportService)
    ], ImportCaseDetail.prototype, "dataImportService", void 0);
    __decorate([
        Prop({ required: true, default: '' })
    ], ImportCaseDetail.prototype, "batchNumber", void 0);
    __decorate([
        Watch('batchNumber', { immediate: true })
    ], ImportCaseDetail.prototype, "updateCaseDetail", null);
    __decorate([
        Emit('onBackCaseList')
    ], ImportCaseDetail.prototype, "onBackCaseList", null);
    ImportCaseDetail = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm
            }
        })
    ], ImportCaseDetail);
    return ImportCaseDetail;
}(Vue));
export default ImportCaseDetail;
